import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import IconJpg from '../../assets/new-icons/jpg-min.png';
import IconPdf from '../../assets/new-icons/pdf-min.png';
// import IconIdCorrect from '../../assets/new-icons/img-pic-id-correct.png';
// import IconIdIncorrect from '../../assets/new-icons/img-pic-id-incorrect.png';
import IconAwesomeCheckCircle from '../../assets/new-icons/ionic-ios-checkmark-circle-outline-green.svg';
import IconAwesomeIncorrect from '../../assets/new-icons/ionic-ios-incorrect-circle-red.svg';
import { useSelector } from 'react-redux';

function RecomendationPhotosModal({
  showModal,
  handleConfirmAttachment = () => {},
  handleHideFormatsModal = () => {},
}) {
  // const { imageFront } = useSelector((state) => state.ocr);
  const location = useLocation();
  const { t } = useTranslation();

  // console.log('Recomendation Modal', imageFront);
  const handleClose = () => {
    console.log(location);
    handleHideFormatsModal();
  };

  const confirmAttachment = () => {
    handleConfirmAttachment();
  };

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      contentClassName="border-0"
      centered
    >
      <Modal.Header className="pt-3 pb-0 border-0" closeButton>
        <Modal.Title className="mx-auto text-center">
          <p className="mb-0 app-fw-notosans-bold app-txt-granite">{t('TXT_TITLE_RECOMENDATION')}</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0 app-txt-granite-80-dark text-center app-fs-15 app-lh-h4">
          {t('TXT_RECOMENDATION_DESCRIPTION')
            .split('\n')
            .map((line, index) => (
              <span key={index}>
                {line}
                <br />
              </span>
            ))}
        </p>

        <div className="d-flex justify-content-center align-items-center mt-4">
          <div className="position-relative mx-3">
            {/* <img src={IconIdIncorrect} alt="Incorrecto" className="img-fluid" style={{ maxHeight: '100px' }} /> */}
            <img src="new-icons/img-pic-id-correct.png" alt="Incorrecto" className="img-fluid" style={{ maxHeight: '100px' }} />
            <img
              src={IconAwesomeIncorrect} // Ícono ❌ personalizado
              alt="Icono incorrecto"
              className="position-absolute start-50 translate-middle"
              style={{ width: '24px', height: '24px', top: '-10px' }}
            />
          </div>

          <div className="vr mx-3" style={{ height: '100px' }}></div>

          <div className="position-relative mx-3">
            {/* <img src={IconIdCorrect} alt="Incorrecto" className="img-fluid" style={{ maxHeight: '100px' }} /> */}
            <img src="new-icons/img-pic-id-incorrect.png" alt="Incorrecto" className="img-fluid" style={{ maxHeight: '100px' }} />
            <img
              src={IconAwesomeCheckCircle} // Ícono ✅ personalizado
              alt="Icono correcto"
              className="position-absolute start-50 translate-middle"
              style={{ width: '24px', height: '24px', top: '-10px' }}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 mx-auto">
        <Button
          variant=""
          onClick={confirmAttachment}
          className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height px-4"
        >
          {t('TXT_BUTTON_TAKE_PHOTO')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default RecomendationPhotosModal;
